import React, { useEffect, useRef, useState } from "react";
import { getProductData } from "@/store/productSlice";
import { DeviceDetector, getLoggedInEmailAddress, navigateAndReplaceHistory } from "@/utils";
import { GetServerSideProps } from "next";
import { getVendors } from "@/store/commonSlice";
import { configureAmplify } from "@/pages/_app";
import ShopifyCart from "@/components/shopify_cart";
import { prepareErrorProps } from "@/components/nesterror";




const CartComponent: React.FC = (props: any) => {

    const serverState = typeof props.message == "string" ? JSON.parse(props.message) : props.message;
    const brand = serverState.brand;
    const brandPathEntry = brand && brand !== "nestingale" ? `/${brand}` : "";
    const brandDisplayName: string = brand && (brand.charAt(0).toUpperCase() + brand.slice(1)) || "Nestingale";
   
    const device = DeviceDetector();

    return (<>
        <ShopifyCart {...props} brand={brandPathEntry}/>
    </>
    )
}

export const getServerSideProps: GetServerSideProps = async (context) => {

    try {

        // configureAmplify({
        //     domain: context.req.headers.host
        //     , protocol: context.req.headers['x-forwarded-proto']
        // });
        const { vendor } = context.params as any;
        const { url } = context.req;
        const vendorsApiData = await getVendors();

        let vendorName = vendorsApiData.vendors.find((vendorObj: any) => vendorObj.vendorName === vendor)?.vendorName as string;


        const pagePropObj = {
            brand: null,  // always null because cart is brand agnostic
            vendorsData: vendorsApiData,
            title : `Shopping Cart`
        };
        const pageProps = JSON.stringify(pagePropObj);

       return {
            props: {
                message: pageProps,
                title: `Shopping Cart`,
                noindex: true,
                dataLayer: {/*title based*/}
            }
        }
    } catch (error) {
        return prepareErrorProps(error, context, "Cart");
    };
}


export default CartComponent;